import {
    DEFAULT_SMART_LIST_ADAPTER_ID,
    DEFAULT_SMART_LIST_SORT_OPTION,
    SMART_LIST_TEMPLATE_DEFINITIONS,
    SmartListTemplateDefinition,
} from "../Api/constants";

export interface SmartListGenreOption {
    value: string;
    label: string;
}

export const SMART_LIST_GENRE_CHOICES: SmartListGenreOption[] = [
    { value: "action", label: "Action" },
    { value: "adventure", label: "Adventure" },
    { value: "animation", label: "Animation" },
    { value: "comedy", label: "Comedy" },
    { value: "drama", label: "Drama" },
    { value: "horror", label: "Horror" },
    { value: "reality", label: "Reality" },
    { value: "romance", label: "Romance" },
    { value: "sci-fi", label: "Sci-Fi" },
    { value: "thriller", label: "Thriller" },
    { value: "travel", label: "Travel" },
    { value: "fantasy", label: "Fantasy" },
];

export type SmartListTemplateChoice = SmartListTemplateDefinition & {
    description?: string;
    defaultSortOption?: string;
    genreOptions?: SmartListGenreOption[];
};

const templateMetadata: Record<string, Partial<SmartListTemplateChoice>> = {
    "107": {
        description: "By Genre",
        defaultSortOption: DEFAULT_SMART_LIST_SORT_OPTION,
        genreOptions: SMART_LIST_GENRE_CHOICES,
    },
    "109": {
        description: "By Tags",
        defaultSortOption: DEFAULT_SMART_LIST_SORT_OPTION,
    },
    "112": {
        description: "Marketing & Promos",
        defaultSortOption: DEFAULT_SMART_LIST_SORT_OPTION,
    },
    "137": {
        description: "Sports",
        defaultSortOption: DEFAULT_SMART_LIST_SORT_OPTION,
    },
};

export const SMART_LIST_TEMPLATE_CHOICES: SmartListTemplateChoice[] =
    SMART_LIST_TEMPLATE_DEFINITIONS.map((choice) => ({
        defaultSortOption: DEFAULT_SMART_LIST_SORT_OPTION,
        ...templateMetadata[choice.templateId],
        ...choice,
    }));

export const getTemplatesForAdapter = (
    adapterId: number | null | undefined,
): SmartListTemplateChoice[] => {
    if (adapterId === null || adapterId === undefined) {
        return SMART_LIST_TEMPLATE_CHOICES;
    }
    return SMART_LIST_TEMPLATE_CHOICES.filter((choice) => choice.adapterId === adapterId);
};

export const getTemplateById = (
    templateId: string | null | undefined,
): SmartListTemplateChoice | undefined => {
    if (!templateId) {
        return undefined;
    }
    return SMART_LIST_TEMPLATE_CHOICES.find((choice) => choice.templateId === templateId);
};

export const DEFAULT_SMART_LIST_TEMPLATE =
    SMART_LIST_TEMPLATE_CHOICES.find((choice) => choice.templateId === "107") ??
    SMART_LIST_TEMPLATE_CHOICES[0];

export const DEFAULT_SMART_LIST_ADAPTER = DEFAULT_SMART_LIST_ADAPTER_ID;
